export enum ReviewTypeEnum {
  Review = "Review",
  Feedback = "Feedback",
  OneMOnboarding = "1M Onboarding",
  ThreeMOnboarding = "3M Onboarding",
}